import { APP_NAME } from '../utils/environment';
import { default as module } from './AbstractModule';
import VimeoPlayer from '@vimeo/player';

const MODULE_NAME = 'VimeoPlayer';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    LAUNCH: `launch.${EVENT_NAMESPACE}`,
    PAUSE: `pause.${EVENT_NAMESPACE}`
};

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$el = $(this.el)

        // Set events and such
        this.player = new VimeoPlayer(this.el)
        if(this.$el.hasClass('is-show')) this.player.play()

        this.timeout;

        this.$el.on(EVENT.LAUNCH, (e) => {
            if(e.way == 'enter'){
                this.timeout = setTimeout(() => {
                    this.player.play();
                },100)
            }
            else {
                clearTimeout(this.timeout);
                this.player.pause();
            }
        })

        this.$el.on(EVENT.PAUSE, (e) => {
            this.player.pause()
        })
    }

    destroy() {
        this.player.destroy();

        // console.log('❌ [module]:destroy - VimeoPlayer');
        super.destroy()
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
